<header>
    <img src="../assets/zoneiq-logo.svg" alt="ZoneIQ logo" />
    <h3 *ngIf="!isAdmin">External Calibration Interface</h3>
    <h3 *ngIf="isAdmin">Calibration Admin</h3>
    <div class="upper-right-corner-container">
        <zoning-code-changes-btn class="changes-logo" *ngIf="!isAdmin"> </zoning-code-changes-btn>
        <app-active-connected-users-btn appTooltip [className]="'connections-popup'" class="connections-logo"
            [activeConnection]="activeConnection" *ngIf="!isAdmin">
        </app-active-connected-users-btn>
        <app-current-zoning-code class="current-zoning-code" *ngIf="!isAdmin"></app-current-zoning-code>
        <app-user-menu class="user-menu"></app-user-menu>
    </div>
</header>

<main>
    <router-outlet></router-outlet>
</main>
